import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import InputComponent from '../../../../component/InputComponent';
import { Button, Col, Form, Row, Spin } from 'antd';
import { AdminUserRequest } from '../../../../request/AuthRequest';
import { Notification } from '../../../../config/Global';
import useStore from '../../../../store';
import Message from '../../../../config/Message';

const UpdateProfile = observer(() => {
	const [form] = Form.useForm();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState();
	const { ADMINUSER, AUTH } = useStore();

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};
	const handleSubmit = (data) => {
		setSaving(true);
		ADMINUSER.editAdimnUser({
			...data,
			id: AUTH.user.id,
			versionNo: AUTH.user.versionNo,
		})
			.then((data) => {
				if (data.httpStatusCode == 200) {
					AUTH.fetchAuthUser();
					Notification.success({
						message: Message().profile,
					});
				} else {
					Notification.error({
						message: Message().global.networkIssue,
					});
				}
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	useEffect(() => {
		if (AUTH.user) {
			form.setFieldsValue({
				firstName: AUTH.user.firstName,
				lastName: AUTH.user.lastName,
				email: AUTH.user.email,
				mobileNo: AUTH.user.mobileNo,
				userName: AUTH.user.userName,
				eAdminRoleId: AUTH.user.eAdminRoleId,
			});
		}
	}, [form, AUTH.user]);

	return (
		<Spin spinning={!AUTH.user}>
			<Form
				layout="vertical"
				id={'UpdateProfile'}
				form={form}
				onFinish={handleSubmit}
				autoComplete="off"
			>
				<Row gutter={24}>
					<Col span={12}>
						<InputComponent
							required
							name="firstName"
							label="First Name"
							placeholder="Enter First Name"
							onChange={handleChange}
							rules={AdminUserRequest.firstName}
						/>
					</Col>
					<Col span={12}>
						<InputComponent
							required
							name="lastName"
							label="Last Name"
							placeholder="Enter Last Name"
							onChange={handleChange}
							rules={AdminUserRequest.lastName}
						/>
					</Col>
					<Col span={12}>
						<InputComponent
							required
							name="email"
							label="Email"
							placeholder="Enter Email Address"
							onChange={handleChange}
							rules={AdminUserRequest.email}
							disabled
						/>
					</Col>
					<Col span={12}>
						<InputComponent
							required
							name="mobileNo"
							label="Mobile No."
							placeholder="Enter Mobile No."
							onChange={handleChange}
							rules={AdminUserRequest.mobileNo}
						/>
					</Col>
					<Col span={12}>
						<InputComponent
							required
							name="userName"
							label="User Name"
							placeholder="Enter User Name"
							onChange={handleChange}
							rules={AdminUserRequest.userName}
							disabled
						/>
					</Col>
					<Col span={12}>
						<InputComponent
							required
							type="select"
							showSearch={false}
							name="eAdminRoleId"
							label="Select Role"
							placeholder="Select Role"
							options={{
								values: [
									{
										eAdminRoleId: AUTH.user?.eAdminRoleId,
										adminRoleName: AUTH.user?.adminRoleName,
									},
								],
								value_key: 'eAdminRoleId',
								text_key: 'adminRoleName',
							}}
							onChange={handleChange}
							rules={AdminUserRequest.role}
							disabled
						/>
					</Col>
				</Row>
				<Button
					type="primary"
					key={1}
					disabled={disabled}
					htmlType="submit"
					loading={saving}
					form="UpdateProfile"
				>
					Update Profile
				</Button>
			</Form>
		</Spin>
	);
});

export default UpdateProfile;
